<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import '../../../design/app.scss';

/**
 * Subscriptions Component
 */
export default {
  page: {
    title: "Subscriptions",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data () {
    return {
      subscriptions: [],
      title: "Subscriptions",
      error: false,
      errorMessage: '',
      success: false,
      successMessage: '',
      submitting: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 500, 1000],
      filter: null,
      filterOn: [],
      sortBy: "createdAt",
      sortDesc: false,
      fields: [
        { key: "licenseKey", label: "Key", sortable: true },
        { key: "userDiscordUsername", label: "Discord", sortable: true },
        { key: "userDiscordId", label: "Discord ID", sortable: true },
        { key: "subscriptionId", label: "Subscription ID", sortable: true },
        { key: "customerId", label: "Customer ID", sortable: true },
        //{ key: "customerEmail", label: "Email", sortable: true },
        { key: "periodEnd", label: "Period end", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "createdAt", label: "Created at", sortable: true },
        { key: "id", label: "Actions    " },
      ]
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.subscriptions.length;
    },
  },
  methods: {
    fetchData () {
      fetch(`/api/v1/administration/getSubscriptions`, {
        credentials: 'include'
      }).then(res => res.json()).then(res => {
        this.subscriptions = []
        for (let i = 0; i < res.length; i++) {
          const subscription = res[i];
          
          this.subscriptions.push({
            id: subscription.id,
            customerId: subscription.customerId,
            //customerEmail: subscription.customerEmail,
            subscriptionId: subscription.subscriptionId,
            licenseKey: subscription.licenseKey,
            isBound: subscription.isBound,
            periodEnd: subscription.periodEnd * 1000,
            status: subscription.status,
            userId: subscription.userId,
            createdAt: (new Date(subscription.createdAt)).getTime(),
            userRole: subscription.user ? subscription.user.role : '',
            userDiscordId: subscription.user ? subscription.user.discord.id : '',
            userDiscordUsername: subscription.user ? subscription.user.discord.username : '',
            userDiscordAvatar: subscription.user ? subscription.user.discord.avatar : '',
            userCreatedAt: subscription.user ? (new Date(subscription.user.createdAt)).getTime() : 0,
          })

          this.title = `Subscriptions (Total: ${this.subscriptions.length}, Active: ${this.subscriptions.filter(r => r.status == 'active').length}, Paused: ${this.subscriptions.filter(r => r.status == 'paused').length})`
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    pause(id) {
      fetch(`/api/v1/administration/pauseSubscription`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ id })
      }).then(() => {
        this.fetchData()
      }).catch(err => {
        console.log(err)
      })
    },
    unbind(id) {
      fetch(`/api/v1/administration/unbindSubscription`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ id })
      }).then(() => {
        this.fetchData()
      }).catch(err => {
        console.log(err)
      })
    },
    cancel(id) {
      fetch(`/api/v1/administration/cancelSubscription`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ id })
      }).then(() => {
        this.fetchData()
      }).catch(err => {
        console.log(err)
      })
    },
    resendEmail(id) {
      this.success = false
      this.successMessage = ''
      fetch(`/api/v1/administration/resendEmail`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ id })
      }).then(() => {
        this.success = true
        this.successMessage = 'Email has been sent successfully!'
      }).catch(err => {
        console.log(err)
      })
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.subscriptions.length;
  },
  created () {
    this.fetchData()
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <b-alert v-model="error" class="mb-4" variant="danger" dismissible>{{ errorMessage }}</b-alert>
                <b-alert v-model="success" class="mb-4" variant="success" dismissible>{{ successMessage }}</b-alert>

                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="subscriptions"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template v-slot:cell(status)="data">
                  <b-badge v-if="data.value == 'active'" variant="success" style="background-color: #34c38f;">Active</b-badge>
                  <b-badge v-if="data.value == 'paused'" variant="warning" style="background-color: #f1b44c;">Paused</b-badge>
                  <b-badge v-if="data.value == 'deleted'" variant="danger" style="background-color: #f46a6a;">Deleted</b-badge>
                </template>
                <template v-slot:cell(periodEnd)="data">{{ data.value ? (new Date(parseInt(data.value))).toLocaleString() : '' }}</template>
                <template v-slot:cell(createdAt)="data">{{ (new Date(parseInt(data.value))).toLocaleString() }}</template>
                <template v-slot:cell(customerId)="data">
                  <a :href="'https://dashboard.stripe.com/customers/' + data.value" target="_BLANK">{{ data.value }}</a>
                </template>
                <template v-slot:cell(subscriptionId)="data">
                  <a :href="'https://dashboard.stripe.com/subscriptions/' + data.value" target="_BLANK">{{ data.value }}</a>
                </template>
                <template v-slot:cell(id)="data">
                  <span class="fa fa-pause" v-on:click="pause(data.value)" style="margin-right:6px;font-size:17px;" title="Pause/Unpause membership"></span>
                  <span class="fa fa-unlink" v-on:click="unbind(data.value)" style="margin-left:6px;margin-right:6px;font-size:17px;" title="Unbind membership"></span>
                  <span class="fa fa-ban" v-on:click="cancel(data.value)" style="margin-left:6px;margin-right:6px;font-size:17px;" title="Cancel membership immediately"></span>
                  <span class="fa fa-paper-plane" v-on:click="resendEmail(data.value)" style="margin-left:6px;font-size:17px;" title="Resend email"></span>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
  
</template>
